import { render, staticRenderFns } from "./list.vue?vue&type=template&id=6cb9a6bb&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=6cb9a6bb&prod&scoped=true&lang=less&"
import style1 from "./list.vue?vue&type=style&index=1&id=6cb9a6bb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb9a6bb",
  null
  
)

export default component.exports